import baseService from './baseService';

export const getWinningAuctions = async () => {
  try {
    const response = await baseService.get(`orders/get-user-all-orders`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getLocalWinningAuction = async () => {
  try {
    const response = await baseService.get(`local-cars/get-user-won-local-cars`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getUserPaidLocalCars = async () => {
  try {
    const response = await baseService.get(`local-cars/get-user-paid-local-cars`);
    return response;
  } catch (error) {
    throw error;
  }
};